export default "__VITE_ASSET__pR6xdDDC__"